<template lang="pug">
.clear-history-modal(v-if="show", @touchmove.prevent)
  .modal-container
    .close(@click="close")
      img(src="https://m.hellobike.com/resource/helloyun/08345/bMneu_x9N6.png")
    .info-title 确认清除全部个性化记录？
    .subtitle 清除后无法根据历史个性记录进行推荐，请谨慎操作
    .footer
      .close-btn(@click='close') 取消
      .confirm(@click="confirm") 确认清除
</template>

<script>
import { userClear } from '@/api/personal-info';
import Toast from '@/components/toast';
import { getTokenAndKey } from '../../../utils';

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    };
  },
  methods: {
    status() {
      this.$emit('update:show', false);
    },
    close() {
      this.status();
    },
    async confirm() {
      const { token } = await getTokenAndKey();
      userClear({ token })
        .then(() => {})
        .catch(() => {});
      Toast.show('清除成功');
      this.status();
    },
  },
};
</script>

<style lang="less" scoped>
.clear-history-modal {
  position: fixed;
  z-index: 100;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
}

.modal-container {
  margin: 2.3rem auto;
  width: 3.2rem;
  background: #fff;
  border-radius: 0.12rem;
  position: relative;
  padding-top: 0.24rem;
  padding-bottom: 0.24rem;

  .close {
    position: absolute;
    top: 0.12rem;
    right: 0.12rem;
    width: 0.16rem;
    height: 0.16rem;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .info-title {
    margin: 0 auto;
    height: 0.25rem;
    font-size: 0.18rem;
    font-weight: 500;
    color: #242729;
    line-height: 0.25rem;
    text-align: center;
  }

  .subtitle {
    text-align: center;
    font-size: 0.14rem;
    font-weight: 400;
    color: #5a6066;
    margin: 0.16rem 0.24rem 0.24rem;
  }

  .footer {
    margin-top: 0.2rem;
    margin-left: 0.16rem;
    display: flex;

    .close-btn {
      width: 1.4rem;
      height: 0.48rem;
      background: #f0f3f5;
      border-radius: 0.08rem;
      font-size: 0.18rem;
      font-weight: 400;
      color: #5a6066;
      line-height: 0.48rem;
      text-align: center;
      margin-right: 0.08rem;
    }

    .confirm {
      width: 1.4rem;
      height: 0.48rem;
      background: #08f;
      border-radius: 0.08rem;
      font-size: 0.18rem;
      font-weight: 500;
      color: #fff;
      line-height: 0.48rem;
      text-align: center;
    }
  }
}
</style>
